import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageLoader from '../components/PageLoader';
import api from '../utils/api';
import { getCityFromHost } from '../utils/getCityFromHost';

const AllTags = () => {
  const [tags, setTags] = useState([]);
  const [featuredTags, setFeaturedTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const city = getCityFromHost();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [tagsRes, featuredTagsRes] = await Promise.all([
          api.get('/tags'),
          api.get('/tags/featured'),
        ]);
        setTags(tagsRes.data);
        setFeaturedTags(featuredTagsRes.data);
      } catch (error) {
        console.error('Error fetching tags:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const cityName = city ? city.charAt(0).toUpperCase() + city.slice(1) : '';

  return (
    <>
      <SEO
        title="All Tags"
        description={`Browse all business tags in ${cityName || 'Fatehabad'}. Discover businesses by tags.`}
        canonical="/tags"
      />

      <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
        <div className="container-custom py-12">
          <div className="mb-8">
            <div className="flex flex-wrap items-center gap-2 mb-4 text-sm">
              <Link to="/" className="text-gray-500 dark:text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors">
                Home
              </Link>
              <span className="text-gray-400 dark:text-gray-500">/</span>
              <span className="text-gray-900 dark:text-gray-50 font-medium">All Tags</span>
            </div>
            <div className="bg-gradient-to-r from-primary-50 to-primary-100 dark:from-primary-900/30 dark:to-primary-900/20 rounded-lg p-6 mb-6 border border-primary-200 dark:border-primary-800">
              <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-50 mb-2">
                All Tags
              </h1>
              <p className="text-gray-600 dark:text-gray-400">
                Browse all business tags to discover businesses by specific attributes
              </p>
            </div>
          </div>

          {loading ? (
            <PageLoader message="Loading tags..." />
          ) : tags.length > 0 ? (
            <div className="bg-white dark:bg-gray-900 rounded-lg p-6 border border-gray-200 dark:border-gray-800 shadow-sm">
              <div className="flex flex-wrap gap-2">
                    {tags.map((tag) => {
                      const isFeatured = featuredTags.some(ft => ft._id === tag._id);
                      return (
                        <Link
                          key={tag._id}
                          to={`/tag/${tag.slug}`}
                          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                            isFeatured
                              ? 'bg-gradient-to-r from-primary-50 to-primary-100 dark:from-primary-900/30 dark:to-primary-900/20 text-primary-700 dark:text-primary-400 border border-primary-300 dark:border-primary-800 hover:from-primary-100 hover:to-primary-200 dark:hover:from-primary-900/40 dark:hover:to-primary-900/30'
                              : 'bg-gray-50 dark:bg-gray-800 text-gray-700 dark:text-gray-300 border border-gray-200 dark:border-gray-700 hover:bg-primary-50 dark:hover:bg-primary-900/20 hover:text-primary-700 dark:hover:text-primary-400 hover:border-primary-300 dark:hover:border-primary-700'
                          }`}
                        >
                          {tag.name}
                        </Link>
                      );
                    })}
              </div>
            </div>
          ) : (
            <div className="bg-white dark:bg-gray-900 rounded-lg p-12 text-center border border-gray-200 dark:border-gray-800 shadow-sm">
              <p className="text-gray-600 dark:text-gray-400">No tags available yet.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AllTags;
